import React,{useEffect,useMemo,useState}from'react';
import{useNavigate}from'react-router-dom';
import API from'../utils/api';
import{RED,BLACK,initialBoard,side,legalMoves,applyMove,gameState}from'../games/xiangqiEngine';

const playMoveSound=()=>{
  try{
    const AudioCtx=window.AudioContext||window.webkitAudioContext;
    if(!AudioCtx)return;

    if(!window.__xiangqiAudioCtx){
      window.__xiangqiAudioCtx=new AudioCtx();
    }

    const ctx=window.__xiangqiAudioCtx;

    if(ctx.state==='suspended'){
      ctx.resume().catch(()=>{});
    }

    const now=ctx.currentTime;
    const osc=ctx.createOscillator();
    const gain=ctx.createGain();

    /*
     * 很短的木棋落盘声：
     * 低频、快速衰减，不会像提示音一样刺耳。
     */
    osc.type='triangle';
    osc.frequency.setValueAtTime(190,now);
    osc.frequency.exponentialRampToValueAtTime(
      95,
      now+0.055
    );

    gain.gain.setValueAtTime(0.0001,now);
    gain.gain.exponentialRampToValueAtTime(
      0.28,
      now+0.003
    );
    gain.gain.exponentialRampToValueAtTime(
      0.0001,
      now+0.075
    );

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.start(now);
    osc.stop(now+0.08);
  }catch(e){}
};

import{chooseAiMove}from'../games/xiangqiAI';
import ChineseChessOnline from'./ChineseChessOnline';

const T={
  rr:'車',rn:'馬',rb:'相',ra:'仕',rk:'帥',rc:'炮',rp:'兵',
  br:'車',bn:'馬',bb:'象',ba:'士',bk:'將',bc:'砲',bp:'卒'
};

const L=[
  '',
  '入门Ⅰ',
  '入门Ⅱ',
  '初级Ⅰ',
  '初级Ⅱ',
  '中级Ⅰ',
  '中级Ⅱ',
  '高级Ⅰ',
  '高级Ⅱ',
  '棋手',
  '高手'
];

export default function ChineseChess(){
  const nav=useNavigate();

  const[mode,setMode]=useState('ai');
  const[b,setB]=useState(initialBoard);
  const[turn,setTurn]=useState(RED);
  const[sel,setSel]=useState(null);
  const[hist,setHist]=useState([]);
  const[lv,setLv]=useState(1);
  const[stat,setStat]=useState(null);
  const[busy,setBusy]=useState(false);
  const[over,setOver]=useState(false);

  useEffect(()=>{
    API.get('/games/xiangqi/profile')
      .then(r=>{
        setStat(r.data);
        setLv(r.data.ai_level||1);
      })
      .catch(()=>{});
  },[]);

  const ms=useMemo(
    ()=>legalMoves(b,turn),
    [b,turn]
  );

  const tg=sel
    ?ms.filter(
      m=>m.from[0]===sel[0]&&
         m.from[1]===sel[1]
    )
    :[];

  const finish=(winner,msg)=>{
    setOver(true);

    if(mode==='ai'){
      API.post(
        '/games/xiangqi/result',
        {
          result:winner===RED?'win':'loss',
          ai_level:lv,
          moves:hist.length+1
        }
      )
      .then(r=>{
        setStat(r.data);
        setLv(r.data.ai_level);
      })
      .catch(()=>{});
    }

    setTimeout(
      ()=>alert(
        (winner===RED?'红方胜':'黑方胜')+
        (msg?' · '+msg:'')
      ),
      50
    );
  };

  const move=m=>{
    const nb=applyMove(b,m);
    playMoveSound();
    const nt=turn===RED?BLACK:RED;
    const nh=[...hist,{b,turn}];

    setB(nb);
    setHist(nh);
    setSel(null);

    const g=gameState(nb,nt);

    if(g.over){
      finish(
        g.winner,
        g.check?'将死':'无棋可走'
      );
    }else{
      setTurn(nt);
    }
  };

  const click=(r,c)=>{
    if(
      over||
      busy||
      (mode==='ai'&&turn===BLACK)
    )return;

    if(sel){
      const m=tg.find(
        x=>x.to[0]===r&&x.to[1]===c
      );

      if(m)return move(m);
    }

    if(
      b[r][c]&&
      side(b[r][c])===turn
    ){
      setSel([r,c]);
    }else{
      setSel(null);
    }
  };

  useEffect(()=>{
    if(
      mode!=='ai'||
      turn!==BLACK||
      over
    )return;

    setBusy(true);

    const t=setTimeout(()=>{
      const m=chooseAiMove(b,lv);

      setBusy(false);

      if(m){
        move(m);
      }else{
        finish(RED,'电脑无棋可走');
      }
    },300);

    return()=>clearTimeout(t);
  },[turn,mode,over]); // eslint-disable-line

  const reset=()=>{
    setB(initialBoard());
    setTurn(RED);
    setSel(null);
    setHist([]);
    setOver(false);
    setBusy(false);
  };

  const change=m=>{
    setMode(m);

    if(m!=='online'){
      reset();
    }
  };

  const undo=()=>{
    if(!hist.length||busy)return;

    const n=
      mode==='ai'&&hist.length>=2
        ?2
        :1;

    const i=hist.length-n;
    const x=hist[i];

    setB(x.b);
    setTurn(x.turn);
    setHist(hist.slice(0,i));
    setSel(null);
    setOver(false);
  };

  return(
    <div style={S.page}>
      <div style={S.top}>
        <button
          onClick={()=>nav(-1)}
        >
          ‹ 返回
        </button>

        <b>中国象棋</b>
        <span/>
      </div>

      <div style={S.tabs}>
        <button
          className={mode==='ai'?'on':''}
          onClick={()=>change('ai')}
        >
          人机对战
        </button>

        <button
          className={mode==='local'?'on':''}
          onClick={()=>change('local')}
        >
          面对面对战
        </button>

        <button
          className={mode==='online'?'on':''}
          onClick={()=>change('online')}
        >
          联机对战
        </button>
      </div>

      {mode==='online'
        ?(
          <ChineseChessOnline/>
        )
        :(
          <>
            {mode==='ai'&&(
              <div style={S.info}>
                {!stat?(
                  <div>
                    正在读取棋力资料…
                  </div>
                ):Number(stat.placement_done)===1?(
                  <>
                    <div style={S.skillMain}>
                      我的棋力：
                      {lv}级 · {L[lv]}
                    </div>

                    <div style={S.skillSub}>
                      棋力分：
                      {stat.skill_rating}
                      {'　'}
                      战绩：
                      {stat.wins}胜
                      {' '}
                      {stat.losses}负
                      {' '}
                      {stat.draws}和
                    </div>

                    <div style={S.opponent}>
                      本局对手：
                      {lv}级 · {L[lv]}
                    </div>
                  </>
                ):(
                  <>
                    <div style={S.skillMain}>
                      定级中：
                      {Math.min(
                        5,
                        Number(stat.placement_games||0)+1
                      )}
                      /5
                    </div>

                    <div style={S.skillSub}>
                      已完成：
                      {Number(stat.placement_games||0)}
                      局
                      {'　'}
                      当前评估分：
                      {stat.skill_rating}
                    </div>

                    <div style={S.opponent}>
                      本局测试对手：
                      {lv}级 · {L[lv]}
                    </div>

                    <div style={S.skillSub}>
                      定级战绩：
                      {stat.wins}胜
                      {' '}
                      {stat.losses}负
                      {' '}
                      {stat.draws}和
                    </div>
                  </>
                )}
              </div>
            )}

            <div style={S.status}>
              {busy
                ?'电脑思考中…'
                :over
                ?'本局结束'
                :(turn===RED?'红方':'黑方')+
                 '走棋'+
                 (gameState(b,turn).check
                   ?' · 将军！'
                   :'')
              }
            </div>

            <div style={S.board}>
              {b.map((row,r)=>
                row.map((p,c)=>{
                  const can=tg.some(
                    x=>x.to[0]===r&&
                       x.to[1]===c
                  );

                  const chosen=
                    sel&&
                    sel[0]===r&&
                    sel[1]===c;

                  return(
                    <button
                      key={r+'-'+c}
                      onClick={()=>click(r,c)}
                      style={{
                        ...S.cell,
                        left:(c*12.5)+'%',
                        top:(r*11.111)+'%'
                      }}
                    >
                      <span style={{
                        ...S.dot,
                        ...(can?S.can:{}),
                        ...(chosen?S.chosen:{})
                      }}>
                        {p&&(
                          <i style={{
                            ...S.piece,
                            color:
                              side(p)===RED
                                ?'#b3261e'
                                :'#222'
                          }}>
                            {T[p]}
                          </i>
                        )}
                      </span>
                    </button>
                  );
                })
              )}

              <div style={S.river}>
                楚 河　　　漢 界
              </div>
            </div>

            <div style={S.act}>
              <button onClick={undo}>
                悔棋
              </button>

              <button onClick={reset}>
                重新开始
              </button>

              <button
                onClick={()=>
                  !over&&finish(
                    turn===RED?BLACK:RED,
                    '认输'
                  )
                }
              >
                认输
              </button>
            </div>

            <p style={S.tip}>
              {mode==='ai'
                ?(
                  stat&&Number(stat.placement_done)===1
                    ?'你执红先行，系统会按照你的棋力自动匹配相应难度。'
                    :'你执红先行，前5局为快速定级赛，系统会根据表现自动调整测试难度。'
                )
                :'同屏双人：红黑双方轮流走棋。'
              }
            </p>
          </>
        )
      }
    </div>
  );
}

const S={
  page:{
    minHeight:'100vh',
    background:'#f3ead7',
    padding:'0 12px 30px'
  },
  top:{
    height:52,
    display:'flex',
    alignItems:'center',
    justifyContent:'space-between'
  },
  tabs:{
    display:'grid',
    gridTemplateColumns:'repeat(3,1fr)',
    gap:6,
    maxWidth:430,
    margin:'0 auto 8px'
  },
  info:{
    maxWidth:430,
    margin:'8px auto 2px',
    padding:'10px 12px',
    textAlign:'center',
    fontSize:13,
    color:'#654',
    background:'#fff8e8',
    border:'1px solid #d9bd87',
    borderRadius:10,
    boxSizing:'border-box'
  },
  skillMain:{
    fontSize:16,
    fontWeight:900,
    color:'#8c2f25',
    marginBottom:4
  },
  skillSub:{
    fontSize:12,
    color:'#765',
    lineHeight:1.7
  },
  opponent:{
    fontSize:14,
    fontWeight:800,
    color:'#49321f',
    marginTop:3
  },
  status:{
    textAlign:'center',
    fontWeight:800,
    color:'#8c2f25',
    height:30,
    paddingTop:8
  },
  board:{
    position:'relative',
    maxWidth:430,
    margin:'0 auto',
    aspectRatio:'8/9',
    backgroundColor:'#d8ad6b',
    backgroundImage:
      'linear-gradient(#6d4c2e 1px,transparent 1px),linear-gradient(90deg,#6d4c2e 1px,transparent 1px)',
    backgroundSize:'12.5% 11.111%',
    border:'3px solid #6d4c2e',
    boxSizing:'border-box'
  },
  cell:{
    position:'absolute',
    width:'12.5%',
    height:'11.111%',
    transform:'translate(-50%,-50%)',
    border:0,
    background:'transparent',
    padding:0,
    zIndex:3
  },
  dot:{
    width:34,
    height:34,
    borderRadius:'50%',
    display:'flex',
    alignItems:'center',
    justifyContent:'center'
  },
  piece:{
    fontStyle:'normal',
    width:32,
    height:32,
    borderRadius:'50%',
    background:'#f6d89d',
    border:'2px solid currentColor',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    fontFamily:'serif',
    fontWeight:900,
    fontSize:20,
    boxShadow:'0 2px 4px #0005'
  },
  can:{
    background:'#278c5577'
  },
  chosen:{
    boxShadow:'0 0 0 4px #ffd700cc'
  },
  river:{
    position:'absolute',
    left:0,
    right:0,
    top:'44.45%',
    height:'11.11%',
    background:'#d8ad6b',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    fontFamily:'serif',
    fontSize:20,
    color:'#6d4c2e',
    zIndex:1
  },
  act:{
    display:'flex',
    gap:10,
    maxWidth:430,
    margin:'14px auto 0',
    justifyContent:'center'
  },
  tip:{
    textAlign:'center',
    fontSize:12,
    color:'#765'
  }
};
